import React, { type FC, useEffect } from 'react';

import { Button } from '@shared/ui/button';

import { MAX_LENGTH_NOTIFICATION } from '../config';
import { useNotifications } from '../hooks';
import { Message } from './message';

import styles from './styles.module.scss';

export const Notifications: FC = () => {
	const { notifications, removeAllNotification, removeFirstNotification, removeNotificationById } =
		useNotifications();

	useEffect(() => {
		if (notifications.length > MAX_LENGTH_NOTIFICATION) {
			removeFirstNotification();
		}
	}, [notifications.length]);

	return (
		<div className={styles.Container}>
			{notifications.length >= MAX_LENGTH_NOTIFICATION && (
				<Button className={styles.HideAll} onClick={removeAllNotification}>
					Убрать все
				</Button>
			)}

			{notifications.map(({ id, message, duration, type, hasRemove }) => (
				<Message
					key={id}
					duration={duration}
					hasRemove={hasRemove}
					id={id}
					message={message}
					type={type}
					onRemove={removeNotificationById}
				/>
			))}
		</div>
	);
};
